import React from 'react'
import { IconProps } from '.'

export function AwardWinnerIcon({
  width = 24,
  height = 24,
  color = 'currentColor',
  ...props
}: IconProps): JSX.Element {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 24 24'
      fill='none'
      aria-hidden
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        d='M10.92 12.443L12 11.623L13.07 12.433C13.46 12.723 13.99 12.353 13.85 11.883L13.43 10.523L14.63 9.57299C15 9.29299 14.79 8.69299 14.31 8.69299H12.91L12.48 7.35299C12.33 6.89299 11.68 6.89299 11.53 7.35299L11.09 8.69299H9.68C9.21 8.69299 9 9.29299 9.37 9.58299L10.56 10.533L10.14 11.893C10 12.363 10.53 12.733 10.92 12.443ZM6 21.303C6 21.983 6.67 22.463 7.32 22.253L12 20.693L16.68 22.253C17.33 22.473 18 21.993 18 21.303V14.973C19.24 13.563 20 11.723 20 9.69299C20 5.27299 16.42 1.69299 12 1.69299C7.58 1.69299 4 5.27299 4 9.69299C4 11.723 4.76 13.563 6 14.973V21.303ZM12 3.69299C15.31 3.69299 18 6.38299 18 9.69299C18 13.003 15.31 15.693 12 15.693C8.69 15.693 6 13.003 6 9.69299C6 6.38299 8.69 3.69299 12 3.69299Z'
        fill={color}
      />
    </svg>
  )
}
